import React, { useEffect, useContext, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Stack, Button } from '@leroy-merlin-br/backyard-react-ui'
import PropTypes from 'prop-types'

import { AlertMessage } from 'reactShared/components/AlertMessage'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'
import { callApiAndUpdateCart, cartProductAdded } from 'reactSite/Cart/services'

import { removeListSubdomain } from 'reactUtils/formatUrlListPage'

import { ProductsList, Summary } from 'checkout/components/MiniCart'
import AssociatedProducts from 'checkout/containers/AssociatedProducts/Associated'
import { Actions } from 'checkout/redux/modules/crossServices'
import { Actions as CartActions } from 'checkout/redux/modules/cart'

import { Header } from '../Header'
import * as S from './styled'

const formattedUrlCart = removeListSubdomain('/carrinho')

const Contents = ({
  discountTotal,
  isCartDrawerOpen,
  resetCart,
  regionId,
  shippings = [],
  subTotal,
  total,
  servicesSubTotal,
  services = [],
  availableServices = []
}) => {
  const { toggleCartDrawer } = useContext(HeaderContext)
  const drawerRef = useRef(null)
  const [currentCartTotalPrice, setCartTotalPrice] = useState(total)
  const [currentShipping, setCurrentShipping] = useState(shippings)
  const [currentCartDiscount, setCartDiscountTotal] = useState(discountTotal)
  const [currentCartSubTotal, setCartSubTotal] = useState(subTotal)
  const [associatedBlackList, setAssociatedBlackList] = useState([])

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(CartActions.setShippings(shippings))
  }, [dispatch, shippings])

  const updateCartTotalPrice = ({
    price = 0,
    subTotal = 0,
    discountTotal = 0,
    total = undefined
  }) => {
    let newTotal
    if (typeof total === 'number') {
      newTotal = total
    } else {
      newTotal = currentCartTotalPrice + price
    }

    if (newTotal < 0) {
      newTotal = 0
    }

    setCartTotalPrice(newTotal)
    setCartDiscountTotal(discountTotal)
    setCartSubTotal(subTotal)
  }

  const removeProductFromCart = ({
    shippingIndex = 0,
    id,
    updateTotal = false
  }) => {
    const newShipping = [...currentShipping]
    const filtered = newShipping[shippingIndex].items.filter(
      product => product.id !== id
    )
    const productToBeRemoved = currentShipping?.[shippingIndex]?.items.find(
      product => product.id === id
    )

    if (productToBeRemoved !== undefined) {
      const { total, discount } = productToBeRemoved.price
      const priceToDecrease = total * -1
      const newDiscountValue =
        currentCartDiscount - parseFloat(discount.toFixed(2))
      const newSubTotalValue =
        currentCartSubTotal -
        (parseFloat(total.toFixed(2)) + parseFloat(discount.toFixed(2)))
      newShipping[shippingIndex].items = filtered

      updateTotal &&
        updateCartTotalPrice({
          price: priceToDecrease,
          subTotal: newSubTotalValue,
          discountTotal: newDiscountValue
        })
      setCurrentShipping(newShipping)

      callApiAndUpdateCart()

      dispatch(Actions.removeService(productToBeRemoved.productId))
    }
  }

  const updateProductAfterIncreaseQnt = ({
    discountTotal,
    id,
    regionId,
    shippings,
    subTotal,
    total,
    uniqueProductsCount,
    zipCode
  }) => {
    setCartSubTotal(subTotal)
    setCartTotalPrice(total)
    setCartDiscountTotal(discountTotal)
    setCurrentShipping(shippings)

    cartProductAdded({
      discountTotal,
      id,
      regionId,
      shippings,
      subTotal,
      total,
      uniqueProductsCount,
      zipCode
    })
  }

  useEffect(() => {
    const shouldReset = currentCartTotalPrice !== 0 && !currentShipping[0]?.items?.length && !isCartDrawerOpen

    if (shouldReset) {
      resetCart()
    }
  })

  useEffect(() => {
    setCurrentShipping(shippings)
  }, [shippings])

  useEffect(() => {
    setCartSubTotal(subTotal)
  }, [subTotal])

  useEffect(() => {
    setCartTotalPrice(total)
  }, [total])

  useEffect(() => {
    setCartDiscountTotal(discountTotal)
  }, [discountTotal])

  useEffect(() => {
    if (currentShipping[0]?.items?.length) {
      const blackList = currentShipping[0].items.map(product => product.id)
      setTimeout(() => {
        setAssociatedBlackList(blackList)
      }, 500)
    }
  }, [currentShipping])

  const firstShipmentType = currentShipping[0]?.type

  return (
    <S.Drawer ref={drawerRef}>
      <Header plural={currentShipping} closeCardDrawer={toggleCartDrawer} />
      {!currentCartTotalPrice
        ? (
        <AlertMessage type="warning">
          Você removeu todos os itens do seu carrinho, aproveite para escolher
          seus produtos novamente.
        </AlertMessage>
          )
        : (
        <ProductsList
          regionId={regionId}
          shipping={currentShipping?.[0]}
          removeProductFromCart={removeProductFromCart}
          updateProduct={updateProductAfterIncreaseQnt}
          services={services}
          availableServices={availableServices}
        />
          )}
      <Stack spacing="mega">
        <S.Line />
        <Summary
          discount={currentCartDiscount}
          subTotal={currentCartSubTotal}
          total={currentCartTotalPrice}
          servicesSubTotal={servicesSubTotal}
        />
        <Button
          data-cy="redirect-to-cart-button"
          size="kilo"
          href={formattedUrlCart}
          isStretch
        >
          Ir para o carrinho
        </Button>
        <AssociatedProducts
          regionId={regionId}
          updateCartTotalPrice={updateCartTotalPrice}
          blackList={associatedBlackList}
          cartType={firstShipmentType}
        />
      </Stack>
    </S.Drawer>
  )
}

Contents.propTypes = {
  products: PropTypes.array,
  subTotal: PropTypes.number,
  discountTotal: PropTypes.number,
  total: PropTypes.number
}

export default Contents
